<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-list-item>
        <v-list-item-icon v-if="icon">
          <v-icon size="32">{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
          <v-list-item-title>
            <v-textarea
              v-model="newValue"
              filled
              :placeholder="subtitle"
              rows="4"
              row-height="30"
              hide-details
              no-resize
              color="black"
            />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default () {
        return [];
      }
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    return { newValue };
  }
};
</script>
